export default __webpack_public_path__ + "static/Multi-lingualAudio_Hover-72b56e9aaea941e26627a3392f22127a.png";